import { FormField, Header, SpaceBetween } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { CustomAppLayout } from '../../../layout';
const _preserve = React.version;
////import { useStoreAdmin } from '../../../../context/useStoreAdmin';
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import { buildBreadcrumbItems, getCookie, getUrlVersion, setLoading, setParameters } from '../../../../commons/functions';


import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import BookingGrid from '../../../../../components/BookingGrid';
import DPModal from '../../../../../components/DPModal';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { useGlobalState } from '../../../../context/GlobalStateContext';
dayjs.extend(isBetween);


const pageSize = 20;
interface HourOption {
    value: string;
    label: string;
}
export const AdminCasinoBookingsPage = () => {
    const { menu, parameters, idUser, data } = useGlobalState();
    const [bookings, setBookings] = useState<any[]>([]);
    const [blockings, setBlockings] = useState<any[]>([]);
    const [info, setInfo] = useState<any>();


    const handleRefresh = async () => {
        if (parameters && parameters.date && parameters.date !== "") {
            try {
                setBookings([]);
                setLoading(true);
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/global/bookings/list',
                        'JWT': getCookie("JWT"),

                    },
                    body: JSON.stringify({
                        dateBetween: parameters.date,
                        blockings: true,
                        idGroupTypes: [119738, 119737],
                        orderBy: "ordenGroupType",
                        order: "ASC",
                        orderBy2: "dateEnd",
                        order2: "ASC"
                    })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }

                const data = await response.json();
                if (data && data.bookings) {
                    setBookings(data.bookings);
                }
                if (data && data.blockings) {
                    setBlockings(data.blockings);
                }

            } catch (error) {
                console.error('Error fetching users:', error);
            } finally {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        handleRefresh();
    }, [parameters.date]);

    return (
        <>
            <CustomAppLayout
                toolsHide={true}
                breadcrumbs={
                    <BreadcrumbGroup
                        items={buildBreadcrumbItems(menu)}
                        expandAriaLabel="Show path"
                        ariaLabel="Breadcrumbs"
                    />
                }
                content={
                    <SpaceBetween size="s">
                        <Header variant="h1" actions={<Favorites />}>Grilla de Reservas</Header>
                        <SpaceBetween size="s" direction="vertical">
                            <SpaceBetween size="s" direction="horizontal">
                                <FormField label="Fecha">

                                    <DPModal width={105} today date={parameters.date} clear={false} tomorrow onConfirm={(date) => {
                                        if (date !== "") {
                                            const updatedParameters = {
                                                ...parameters, // clone existing keys
                                                date: (date) // add or update
                                            };
                                            setParameters(updatedParameters);
                                        }
                                    }} />
                                </FormField>
                            </SpaceBetween>
                        </SpaceBetween>
                        <BookingGrid bookings={bookings} blockings={blockings} date={parameters.date} showPrivates={false} showOnlyBookings={false}
                            idGroupTypes={[119737, 119738]}
                        />

                    </SpaceBetween>
                }
            />
        </>
    )
};
